import React from 'react';
import { Link } from 'react-router-dom';
import SubPageHeader from '../../../components/common/SubPageHeader';


const DesignMen = () => {
  return (
    <div className="min-h-screen bg-white">
      <SubPageHeader title="DESIGN24: MEN" />

      <div className="py-10 md:py-20 px-4 md:px-6">
        <div className="max-w-4xl mx-auto border-4  md:border-[12px] border-[#003366] rounded-2xl shadow-2xl p-5  sm:p-8 md:p-16">
          <div className="space-y-4  md:space-y-6 text-[#1a1a1a] text-[15px] md:text-[17px] leading-7  md:leading-relaxed font-medium">
            <p>Every person in this world has <span className="font-bold">24 hours</span> to be successful and live their dream life—be it the president of America or a business tycoon or you and me.</p>
            <p>How perfectly, meticulously we plan every second of the available 24 hours decides our success or failure. <span className="font-bold">DESIGN24 COURSE</span> helps you to PLAN your 24 hours with a focus on your dreamlist.</p>
            <p>DESIGN24 helps you to prepare your consolidated, comprehensive dreamlist to achieve your peak HAPPINESS INDEX. Money or materialistic gains alone does not make a person happy.</p>
            <p>DESIGN24 focuses on the different parameters which ensure happiness every moment of the day. There are some basics to be HAPPY irrespective of your financial status, age, profession and work profile.</p>
            <p>DESIGN 24 teaches you these tools and techniques to maintain your HAPPINESS INDEX consistently. Every HAPPINESS AMBASSADOR who has undergone DESIGN24 COURSE is successfully living life with passion.</p>
            <p>DESIGN24 helps you categorize relations in your life with a filter system to ensure all cordial relations in your personal, professional & social life. You learn to face and overcome any critical situation in life and <span className="font-bold">BOUNCE BACK!</span></p>
            <p className="text-base sm:text-lg  md:text-xl uppercase font-bold text-[#003366] leading-relaxed">Learn to UNLEASH YOUR PEAK POTENTIAL - YOUR BEST VERSION.</p>
          </div>

          <div className="mt-12 text-center space-y-6">
            <p className="text-[#003366] font-bold text-base sm:text-lg md:text-xl  uppercase tracking-wide  text-center leading-relaxed">
              SO REGISTER yourself and book a strategic appointment to become a HAPPINESS AMBASSADOR! <br />
              JOIN THE HAPPINESS FAMILY!
            </p>
            <div className="pt-4">
              <Link
                to="/TGSH/login"
                className="
                  inline-block
                  w-full
                  sm:w-auto
                  bg-[#003366]
                  text-white
                  px-8
                  md:px-10
                  py-3
                  rounded-full
                  font-bold
                  uppercase
                  tracking-wide
                  hover:bg-[#005f8d]
                  transition-all
                  shadow-lg
                  active:scale-95
                "
              >
                Login To Continue
              </Link>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default DesignMen;